import React, {Component, Fragment} from 'react';
import TextField from '@material-ui/core/TextField/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Grid from "@material-ui/core/Grid";

import Divider from "@material-ui/core/Divider";
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import {FieldsJs} from "../../../../settings/General/General";
import Slide from "@material-ui/core/Slide";
import {BotonAccionAbrirModal} from "../../../Include/MiniComponents/GlobalComponent";
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import * as PropTypes from "prop-types";
import {AdquisicionService} from "../../../../services/AdquisicionService/AdquisicionService";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import money_pay_confirm from "../../../../assets/img/icons/money_pay_confirm.svg";
import money_pay_cancel from "../../../../assets/img/icons/money_pay_cancel.svg";
import DivSvg from "../../../Include/MiniComponents/DivSvg";
import Fab from "@material-ui/core/Fab";

class ModalConfirmacionPago extends Component {
	
	state = {};
	
	Usr = {};
	
	constructor(props) {
		super(props);
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		
		this.state = {
			modal: {
				open: false
			},
			
			tipo: props.tipo,
			
			id_adquisicion: (props.item || {}).id_adquisicion,
			id_adquisicion_pago: (props.item || {}).id_adquisicion_pago,
			item: (props.item || null),
			confirmar: '',
		};
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			}
		});
		console.log(this.state, props);
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
			console.log(e);
		});
	};
	
	RefreshInit = () => {
		this.init();
	};
	
	init = () => {
		return new Promise((resolve) => {
			resolve(true);
		});
	};
	
	save = () => {
		AdquisicionService.ConfirmarPago(this.state).then((response) => {
			this.props.RefreshList();
			this.close();
			this.props.showSnackBars('success', response.mensaje);
		}).catch((error) => {
			this.props.showSnackBars('error', error.mensaje);
		});
	};
	
	add = () => {
		const {item} = this.props;
		console.log("this.props ADD::", this.props);
		this.setState({
			id_adquisicion: item.id_adquisicion || '',
			id_adquisicion_pago: item.id_adquisicion_pago || '',
			item: item || null,
			confirmar: '',
			activo: true
		});
		
		this.open();
	};
	
	confirm = (tipo) => {
		this.setState({
			confirmar: tipo,
		});
	}
	
	render() {
		
		let funcion;
		
		switch (this.state.tipo) {
			case 'edit':
				funcion = this.edit;
				break;
			case 'add':
				funcion = this.add;
				break;
			case 'view':
				funcion = this.view;
				break;
			default:
				funcion = () => {
				};
		}
		
		return (
			<div>
				
				{this.props.componente ? (
					<Fragment>
						<span
							style={{cursor: 'pointer'}}
							children={this.props.componente}
							onClick={() => funcion()}
						/>
					</Fragment>
				) : (
					<BotonAccionAbrirModal
						id={this.state.id_cat_sexo}
						tipo={this.state.tipo}
						onClick={() => funcion()}
					/>
				)}
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'sm'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>
						<Typography variant={'h5'} className={'text-left'}>
							{"Confirmar Pago"}
						</Typography>
					</DialogTitle>
					
					<DialogContent>
						
						<Grid container spacing={2}>
							
							<Grid item xs={12} sm={12} md={6} lg={6} xl={6} align={"center"}>
								<Typography variant={'h5'} className={'text-center px-14'}>
									{"Confirmar Pago"}
								</Typography>
								<Button onClick={() => this.confirm(1)} style={{backgroundColor: Number(this.state.confirmar) === 1 ? '#ccc' : ''}}>
									<DivSvg img={money_pay_confirm} height={'180px'} width={'200px'} opacity={true}/>
								</Button>
							</Grid>
							
							<Grid item xs={12} sm={12} md={6} lg={6} xl={6} align={"center"}>
								<Typography variant={'h5'} className={'text-center px-14'}>
									{"Rechazar Pago"}
								</Typography>
								<Button onClick={() => this.confirm(2)} style={{backgroundColor: Number(this.state.confirmar) === 2 ? '#ccc' : ''}}>
									<DivSvg img={money_pay_cancel} height={'180px'} width={'200px'} opacity={true}/>
								</Button>
							</Grid>
						
						</Grid>
					
					</DialogContent>
					
					<DialogActions>
						
						<Fragment>
							<Button onClick={this.close} color="primary">
								{'Cancelar'}
							</Button>
							<Button onClick={this.save} color="primary">
								{'Guardar'}
							</Button>
						</Fragment>
					
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalConfirmacionPago.propTypes = {
	componente: PropTypes.element,
	tipo: PropTypes.string.isRequired,
	item: PropTypes.object.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ModalConfirmacionPago;
